import { render } from "./TableActions.vue?vue&type=template&id=c055ebf6&scoped=true"
import script from "./TableActions.vue?vue&type=script&lang=js"
export * from "./TableActions.vue?vue&type=script&lang=js"

import "./TableActions.vue?vue&type=style&index=0&id=c055ebf6&scoped=true&lang=scss"

import exportComponent from "/opt/esim/admin-src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c055ebf6"]])

export default __exports__